export const txtBrideGroomTitle = {
  id: "Kedua Mempelai",
  en: "The Bride & The Groom",
};

export const txtBrideName = {
  id: "Adila Salma Khansa",
  en: "Adila Salma Khansa",
};

export const txtBrideInfo = {
  id: "Putri dari",
  en: "Daughter of",
};

export const txtBrideFather = {
  id: "Bapak Yulianta",
  en: "Mr. Yulianta",
};

export const txtBrideMother = {
  id: "Ibu Retno Kustiani",
  en: "Mrs. Retno Kustiani",
};

export const txtGroomName = {
  id: "Rafdian Ramadhan",
  en: "Rafdian Ramadhan",
};

export const txtGroomInfo = {
  id: "Putra dari",
  en: "Son of",
};

export const txtGroomFather = {
  id: "Bapak Hakim Budiono",
  en: "Mr. Hakim Budiono",
};

export const txtGroomMother = {
  id: "Ibu Noening Indrijati",
  en: "Mrs. Noening Indrijati",
};
